import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { Validators, FormGroup, FormBuilder, AbstractControl } from '@angular/forms';
import { ModalResult, ModalAnswer } from '../../../shared/models/shared.model';
import { Employee } from '../../model/distributor.model';
import { AdaService } from '../../../shared/services/ada.service';

@Component({
  selector: 'app-employee-edit',
  templateUrl: './employee-edit.component.html',
  styleUrls: ['./employee-edit.component.scss']
})
export class EmployeeEditComponent implements OnInit {

  @Input() visible = false;
  @Input() employee: Employee = new Employee({});
  @Input() employers: Array<string>;
  @Output() visibleChange: EventEmitter<boolean> = new EventEmitter<boolean>();
  @Output() onModalClose: EventEmitter<ModalResult> = new EventEmitter<ModalResult>();

  submitted = false;
  form: FormGroup;

  errorMessages = {
    'firstName.required': 'First Name is required',
    'lastName.required': 'Last Name is required',
    'phone.required': 'Phone is required',
    'email.required': 'Email is required',
    'email.email': 'Email is invalid',
    'previousEmployer.required': 'Previous Employer is required'
  };
  errors = [];

  constructor(private fb: FormBuilder, private _adaService: AdaService) {

  }

  ngOnInit() {
    this.createForm();
  }

  createForm() {
    this.form = this.fb.group(
      {
        firstName: ['', Validators.required],
        lastName: ['', Validators.required],
        phone: ['', Validators.required],
        email: ['', [Validators.required, Validators.email]],
        previousExperience: [''],
        previousEmployer: ['']
      });

    this.form.get('previousExperience').valueChanges.subscribe(cb => {
      const emp = this.form.get('previousEmployer');
      emp.clearValidators();
      if (cb === true) {        // Set previous Employer to required
        emp.setValidators([Validators.required]);
      } else {
        // remove required validaor
        emp.clearValidators();
      }
      emp.updateValueAndValidity();
    });
  }



  get formControls() {
    return this.form.controls;
  }

  onCancel() {
    this.onModalClose.emit({answer: ModalAnswer.CANCEL, data: this.employee});
  }

  onSubmit() {
    this.prepareValidationSummary();
    this.submitted = true;
    if (this.form.valid) {
      this.employee = this.form.value;
      this.onModalClose.emit({answer: ModalAnswer.OK, data: this.employee});
      console.table(this.form.value);
    }
  }

  prepareValidationSummary() {
    this.errors.length = 0;
    for (const field in this.form.controls) { // 'field' is a string
      const control = this.form.get(field); // 'control' is a FormControl
      if (control.errors) {
        for (const error in control.errors) {
          const key = field + '.' + error;
          const x = this.errorMessages[key];
          this.errors.push(x);
        }
      }
    }
    console.table(this.errors);
  }

  whenPopupHidden(e) {
    this.visible = false;
    this.visibleChange.emit(this.visible);
  }

  get adaService() {
    return this._adaService;
  }

}



// WEBPACK FOOTER //
// ./src/app/distributor/components/employee-edit/employee-edit.component.ts